import React from 'react';
import {useSelector} from "react-redux";
import WhatsNewAreaMobile from "./WhatsNewAreaMobile";
import WhatsNewAreaDesktop from "./WhatsnewAreaDesktop";

const WhatsNewArea = ({extraStyle}) => {
    const {isMobile} = useSelector(state => state.styles);

    return isMobile ? <WhatsNewAreaMobile extraStyle={extraStyle}/> : <WhatsNewAreaDesktop extraStyle={extraStyle}/>;
};

export default WhatsNewArea;
